import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class ConversationService {
  private serviceUrl: string;
  constructor(private http: HttpClient, private globals: Globals, private env: EnvService) { this.serviceUrl = this.env.servicePath }

  converse(query: string) {
    var path = this.serviceUrl +"Converse/" + query ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }
  
  saveUtteranceForJob(utterance: string, jobId: string) {
    var path = this.serviceUrl +"SaveUtteranceForJob/" + jobId + "/" + utterance;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  saveUtteranceForPersonalizedView(utterance: string, selectedViewId: string) {
    var path = this.serviceUrl +"SaveUtteranceForPersonalizedView/" + selectedViewId + "/" + utterance;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  saveUtteranceForEPIC(utterance: string, epicId: string) {
    var path = this.serviceUrl + 'SaveUtteranceForEPIC/' + epicId + '/' + utterance;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true',
      'User': this.globals.Session.Session.UserId, 'Session': this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  saveUserTagForEPIC(tagValue: string, documentId: string) {
    var path = this.serviceUrl + 'SaveUserTagForEPIC/' + documentId + '/' + tagValue;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true',
      'User': this.globals.Session.Session.UserId, 'Session': this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  saveMetadataForEPIC(templateType: string, epicId: string) {
    var path = this.serviceUrl + 'SaveMetadataForEPIC/' + templateType + '/' + epicId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true',
      'User': this.globals.Session.Session.UserId, 'Session': this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  getObjects(tag: string) {
    var path = this.serviceUrl +"GetObjects/" + tag ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSuggestions(key: string, keyword: string){
    var path = this.serviceUrl +"GetSuggestions/"+ key + "?param=" + keyword;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }
}
